import "./namespace.js";
import "#/legacy/namespaces.js";

// Uses an anchor tag to simulate a link click in the Light DOM. This allows event handlers to intercept the click if
// desired.
DoctorFinder.Helpers.navigateToUrlUsingAnchorTag = (url, container = document.body) => {
  const a = jQuery("<a>", { href: url }).appendTo(container);
  a[0].click();
  return a.remove();
};
